
export default (key) =>{
    switch (key) {
        case 'de':
            return 'Deutsch';
        case 'en':
            return 'Englisch';
    }
}
